import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './ChaptersList.css';

const ChaptersList: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Mock data
  const course = {
    title: 'Advanced Mathematics',
    progress: 35,
    chapters: [
      { 
        id: 1, 
        title: 'Introduction to Calculus', 
        duration: '45 min',
        videosCount: 5,
        isCompleted: true,
        progress: 100,
        isFree: true
      },
      { 
        id: 2, 
        title: 'Differential Equations', 
        duration: '60 min',
        videosCount: 8,
        isCompleted: false,
        progress: 50,
        isFree: false
      },
      { 
        id: 3, 
        title: 'Integration Techniques', 
        duration: '55 min',
        videosCount: 6,
        isCompleted: false,
        progress: 0,
        isFree: false
      },
      { 
        id: 4, 
        title: 'Advanced Applications', 
        duration: '70 min',
        videosCount: 10,
        isCompleted: false,
        progress: 0,
        isFree: false
      }
    ]
  };

  const handleChapterClick = (chapterId: number, isLocked: boolean) => {
    if (!isLocked) {
      navigate(`/course/${id}/chapter/${chapterId}`);
    }
  };

  return (
    <div className="chapters-list-page">
      <header className="chapters-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ←
        </button>
        <h1>{course.title}</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="chapters-content">
        {/* Progress Section */}
        <div className="course-progress-card">
          <div className="progress-header">
            <span className="progress-label">Course Progress</span>
            <span className="progress-percentage">{course.progress}%</span>
          </div>
          <div className="progress-bar-large">
            <div 
              className="progress-fill-large"
              style={{ width: `${course.progress}%` }}
            ></div>
          </div>
        </div>

        {/* Chapters List */}
        <div className="chapters-section">
          <h2 className="section-title">Chapters ({course.chapters.length})</h2>
          {course.chapters.map((chapter, index) => {
            const isLocked = !chapter.isFree && chapter.progress === 0 && !chapter.isCompleted;
            
            return (
              <div
                key={chapter.id}
                className={`chapter-card ${isLocked ? 'locked' : ''} ${chapter.isCompleted ? 'completed' : ''}`}
                onClick={() => handleChapterClick(chapter.id, isLocked)}
              >
                <div className="chapter-left">
                  <div className={`chapter-number-large ${chapter.isCompleted ? 'completed' : ''}`}>
                    {chapter.isCompleted ? '✓' : index + 1}
                  </div>
                  <div className="chapter-info">
                    <h3 className="chapter-title">{chapter.title}</h3>
                    <div className="chapter-details">
                      <span className="chapter-videos">📹 {chapter.videosCount} videos</span>
                      {chapter.isFree && <span className="free-badge-small">Free</span>}
                    </div>
                    {chapter.progress > 0 && !chapter.isCompleted && (
                      <div className="chapter-progress-mini">
                        <div className="progress-bar-mini">
                          <div 
                            className="progress-fill-mini"
                            style={{ width: `${chapter.progress}%` }}
                          ></div>
                        </div>
                        <span className="progress-text-mini">{chapter.progress}%</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="chapter-right">
                  {isLocked ? (
                    <span className="lock-icon-large">🔒</span>
                  ) : chapter.isCompleted ? (
                    <span className="check-icon">✓</span>
                  ) : (
                    <button className="play-icon-button">▶</button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default ChaptersList;
